/**
 * MIME Resolver class
 */
export default class MimeResolver {
    /**
     * @param {Logger} logger
     */
    constructor(logger) {
        this.logger = logger;
    }

    /**
     * To get MIME type from media URL
     * @param {string} mediaUrl
     * @returns {promise} including Media MIME type or empty string
     */
    getMimeType(mediaUrl) {
        this.logger.info(`[Receiver] getMimeType for url: ${mediaUrl}`);

        return new Promise((resolve) => {
            let mimetype = '';
            const linkEl = document.createElement('a');
            let xhr = null;
            linkEl.href = mediaUrl;
            const filename = linkEl.pathname.match(/\/[^/]*$/gi)[0];
            switch (filename.split('.').pop()) {
                case 'mp4':
                case 'mov':
                    mimetype = 'video/mp4';
                    break;
                case 'mp3':
                    mimetype = 'audio/mp3';
                    break;
                case 'm3u':
                case 'm3u8':
                    mimetype = 'application/x-mpegURL';
                    break;
                case 'mpd':
                    mimetype = 'application/dash+xml';
                    break;
                case '/':
                    xhr = new XMLHttpRequest();
                    xhr.addEventListener('load', (event) => {
                        if (event.target.responseURL) {
                            // TODO check if working
                            mimetype = this.getMimeType(event.target.responseURL);
                        } else {
                            mimetype = this.getMimeType(event.target.responseText);
                        }
                        resolve(mimetype);
                    });
                    xhr.open('GET', mediaUrl);
                    xhr.send();
                    break;
                default:
                    mimetype = '';
                    resolve(mimetype);
                    break;
            }
            if (mimetype !== '') {
                resolve(mimetype);
            }
        });
    }
}
